export class ModalService {

   public showMessageModal(message: string): void {
      const el = document.getElementById("modalMessage");
      if (!el) return;
      el.innerHTML = message;
      //@ts-ignore
      const modal = new bootstrap.Modal(document.getElementById("messageModal"));
      modal.show();
   }

}